export default "/_nuxt/54aa0e45946451970d5300aef2e2e08d.svg";